var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.165 137.199H113.324V99.8401C113.324 90.9315 113.143 79.4669 100.9 79.4669C88.4695 79.4669 86.571 89.1605 86.571 99.1827V137.199H62.7296V60.375H85.6319V70.8467H85.9405C89.1403 64.8092 96.922 58.4363 108.548 58.4363C132.704 58.4363 137.172 74.335 137.172 95.0303V137.199H137.165ZM35.8024 49.863C28.128 49.863 21.9631 43.6511 21.9631 36.0103C21.9631 28.3763 28.1348 22.171 35.8024 22.171C43.4499 22.171 49.6484 28.3763 49.6484 36.0103C49.6484 43.6511 43.4432 49.863 35.8024 49.863ZM47.7566 137.199H23.8481V60.375H47.7566V137.199ZM149.093 0H11.8805C5.313 0 0 5.19225 0 11.5987V149.401C0 155.814 5.313 161 11.8805 161H149.073C155.633 161 161 155.814 161 149.401V11.5987C161 5.19225 155.633 0 149.073 0H149.093Z",
    fill: "#ccdfff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.a346bec72e249a7f6d7beb3cb3dbaebd.svg";
export { ForwardRef as ReactComponent };